import { NavLink, Outlet } from 'react-router-dom';
import { CalendarDays, KanbanSquare, LayoutDashboard, LineChart, List } from 'lucide-react';
import { cn } from '@/lib/utils';
import { t } from '@/locales/i18n';
import { usePermission } from '@/hooks/usePermission';
import { AccessDenied } from '@/components/AccessDenied';

interface NavItem {
  to: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
}

const ITEMS: NavItem[] = [
  { to: '/crm', label: t('crm.nav.dashboard'), icon: LayoutDashboard },
  { to: '/crm/kanban', label: t('crm.nav.kanban'), icon: KanbanSquare },
  { to: '/crm/liste', label: t('crm.nav.liste'), icon: List },
  { to: '/crm/forecasting', label: t('crm.nav.forecasting'), icon: LineChart },
  { to: '/crm/agenda', label: t('crm.nav.agenda'), icon: CalendarDays },
];

export function CrmLayout(): JSX.Element {
  const canView = usePermission('crm.view');
  if (!canView) return <AccessDenied feature="crm.view" />;
  return (
    <div className="flex h-full flex-col">
      <div className="border-b border-border bg-card">
        <div className="flex items-end gap-1 overflow-x-auto px-4">
          {ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/crm'}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2 whitespace-nowrap border-b-2 px-3 py-3 text-sm transition-colors',
                  isActive
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted-foreground hover:border-border hover:text-foreground',
                )
              }
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
      <div className="scrollbar-thin flex-1 overflow-y-auto bg-secondary/20">
        <Outlet />
      </div>
    </div>
  );
}
